import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormikContext } from "formik";
import {
    getPaymentTypeInitialValue,
    UpdateShouldReauthorizePayPal,
} from "@qgiv/core-donor";
import {
    selectAppSettings,
    setHasCompletedPayPalAuthorizationFlow,
    setHasInitiatedPayPalAuthorizationFlow,
    setPayPalPaymentSource,
} from "../../../../redux/slices/appSettingsSlice";
import { selectAllDonationDetails } from "../../../../redux/slices/donationDetailsSlice";
import { selectDonorAccount } from "../../../../redux/slices/donorAccountSlice";
import { selectAllFormSettings } from "../../../../redux/slices/formSettingsSlice";

/**
 *
 * @returns {React.ReactElement}
 */
const ConnectedUpdateShouldReauthorizePayPal = () => {
    const dispatch = useDispatch();
    const formikContext = useFormikContext();
    const appSettings = useSelector(selectAppSettings);
    const donationDetails = useSelector(selectAllDonationDetails);
    const donorAccount = useSelector(selectDonorAccount);
    const formSettings = useSelector(selectAllFormSettings);
    const { payPal } = appSettings;
    const { giftDetails } = donationDetails;
    const { initialValues, setFieldValue } = formikContext;
    const { paymentData } = formSettings;
    const { hasSelectedRecurringDonation, total } = giftDetails;
    const {
        hasCompletedPayPalAuthorizationFlow,
        hasInitiatedPayPalAuthorizationFlow,
        paymentMethodResetCount,
    } = payPal;

    const paymentTypeInitialValue = getPaymentTypeInitialValue(
        paymentData,
        donorAccount,
    );

    // Cannot use the payment type from the initial value object as we need
    // the payment type associated with the new payment method UI.
    const initialPaymentTypeForNewPaymentMethods = paymentTypeInitialValue;
    const valuesThatShouldForceReauthorization = [
        hasSelectedRecurringDonation,
        paymentMethodResetCount,
        total,
    ];

    /**
     * Wipe all of the pre-existing PayPal values and replace them with the
     * initial versions of these values while also updating any PayPal related
     * data in the Redux store.
     * @returns {void}
     */
    const handleResetPayPalAuthorizationFlow = () => {
        setFieldValue("Payment_Type", initialPaymentTypeForNewPaymentMethods);
        setFieldValue("PayPal_Agreement_ID", initialValues.PayPal_Agreement_ID);
        setFieldValue("PayPal_Is_Venmo", initialValues.PayPal_Is_Venmo);
        setFieldValue("PayPal_Payer_ID", initialValues.PayPal_Payer_ID);
        setFieldValue("PayPal_Token", initialValues.PayPal_Token);

        dispatch(setHasInitiatedPayPalAuthorizationFlow(false));
        dispatch(setHasCompletedPayPalAuthorizationFlow(false));
        dispatch(setPayPalPaymentSource("paypal"));
    };

    return (
        <UpdateShouldReauthorizePayPal
            handleResetPayPalAuthorizationFlow={
                handleResetPayPalAuthorizationFlow
            }
            hasCompletedPayPalAuthorizationFlow={
                hasCompletedPayPalAuthorizationFlow
            }
            hasInitiatedPayPalAuthorizationFlow={
                hasInitiatedPayPalAuthorizationFlow
            }
            valuesThatShouldForceReauthorization={
                valuesThatShouldForceReauthorization
            }
        />
    );
};

export default ConnectedUpdateShouldReauthorizePayPal;
